module.exports = __webpack_public_path__ + "assets/img/mosaic-columns-2.d984da47.jpg";